var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, injectable } from "tsyringe";
import { ValidateToken } from "./IValidate.js";
import { matches } from "./Program.js";
import { services } from './Services.js';
export class Dependency {
    constructor() {
        this.operator = '=';
        this.value = null;
    }
}
export class DependencyValidatorOptions {
    constructor() {
        // public dependencies: Element[] = [];
        this.evaluators = [];
        // public values: Map<Element, string> = new Map();
        this.depends = '';
        this.condition = 'or';
        this.emptyOnDisable = false;
        this.resetOnDisable = true;
        // public conditionalRequired: boolean = true;
        // public required: boolean = false;
        this.disabledClass = 'disabled';
        // public target: string | null = null;
        this.disableChildren = true;
    }
}
export const DependencyValidatorOptionsToken = 'DependencyValidatorOptions';
const operations = new Map([
    // ['!=', (el, value) => el.value != value],
    ['!=', (el, value) => !matches(el.value, value)],
    // ['!', (disabled) => !disabled],
    ['>=', (el, value) => el.value >= value],
    ['<=', (el, value) => el.value <= value],
    ['=', (el, value) => matches(el.value, value)],
    ['>', (el, value) => el.value > value],
    ['<', (el, value) => el.value < value],
]);
// operations.set('', () => null);
const operationsKeys = Array.from(operations.keys());
let DependencyValidator = class DependencyValidator {
    constructor(containingForm, options) {
        this.message = 'Dependency condition not met';
        this.selector = '[data-depend-options]';
        this.optionsCache = new Map();
        this.checkDependencies = async (event) => {
            console.log('checking dependencies', this.optionsCache);
            // todo: check to see if event.target is part of optionsCache's entry dependencies.
            for (const [element, options] of this.optionsCache) {
                await this.validate(element);
            }
            ;
        };
        this.form = containingForm;
        this.options = options;
        this.currentOptions = options;
    }
    connect(form) {
        this.form.querySelectorAll(this.selector).forEach((element) => {
            if (element instanceof HTMLElement)
                this.getOptions(element);
        });
        // initial validation
        this.optionsCache.forEach((options, element) => { this.validate(element); });
        this.form.addEventListener('change', this.checkDependencies);
    }
    ;
    disconnect() {
        this.form.removeEventListener('change', this.checkDependencies);
    }
    ;
    async validate(input) {
        const options = this.getOptions(input);
        if (options == null)
            return Promise.resolve(true);
        // let isValid: boolean;
        let opValid;
        if (options.condition === 'or') {
            opValid = options.evaluators.some((evaluator) => evaluator() === true);
        }
        else {
            opValid = options.evaluators.every((evaluator) => evaluator() === true);
        }
        if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement || input instanceof HTMLTextAreaElement)
            input.disabled = !opValid;
        input.classList.toggle(options.disabledClass, !opValid);
        const targets = elementSelectorAll(input, 'input,select,textarea');
        if (!opValid) {
            if (options.disableChildren)
                targets.forEach((el) => el.setAttribute('disabled', 'disabled'));
            if (options.resetOnDisable)
                targets.forEach((el) => elementResetValue(el));
            else if (options.emptyOnDisable)
                targets.forEach((el) => elementClearValue(el));
        }
        else {
            if (options.disableChildren)
                targets.forEach((el) => el.removeAttribute('disabled'));
        }
        return Promise.resolve(opValid);
    }
    getOptions(input) {
        let options = this.optionsCache.get(input);
        if (!options) {
            try {
                options = Object.assign({}, this.options, elementOptions(input, 'data-depend-'));
            }
            catch (error) {
                console.error('Error parsing data-depend-options attribute:', error);
            }
            if (!options)
                return null;
            options.evaluators = options.depends.split(',').map((depend) => {
                depend = depend.trim();
                let operator = operationsKeys.find(op => depend.includes(op)) ?? '!=';
                let selector = null;
                let value = '';
                if (operator) {
                    const parts = depend.split(operator);
                    selector = parts[0];
                    value = parts[1] ?? '';
                }
                else if (depend.startsWith('!')) {
                    operator = '=';
                    selector = depend.substring(1);
                }
                else {
                    selector = depend;
                }
                const target = this.form.querySelector(`#${CSS.escape(selector)}`)
                    ?? this.form.querySelector(`[name="${CSS.escape(selector)}"]`);
                if (target instanceof HTMLInputElement) {
                    //todo: handle checkboxes/radio buttons, and select elements
                    if (target.type === 'checkbox' || target.type === 'radio') {
                        return (operator === "!=") ? () => target.checked : () => !target.checked;
                    }
                    return () => {
                        const isValid = operations.get(operator)(target, value);
                        return isValid;
                    };
                }
                if (target instanceof HTMLSelectElement) {
                    return () => {
                        const isValid = operations.get(operator)(target, value);
                        return isValid;
                    };
                }
                if (target instanceof HTMLOptionElement) {
                    return (operator === "!=") ? () => target.selected : () => !target.selected;
                }
            }).filter(op => op !== undefined);
            this.optionsCache.set(input, options);
        }
        return options;
    }
    getElement(selector) {
        return this.form.querySelector(`#${CSS.escape(selector)}`)
            ?? this.form.querySelector(`[name="${CSS.escape(selector)}"]`);
    }
    ;
};
DependencyValidator = __decorate([
    injectable(),
    __param(1, inject(DependencyValidatorOptionsToken)),
    __metadata("design:paramtypes", [HTMLFormElement,
        DependencyValidatorOptions])
], DependencyValidator);
export { DependencyValidator };
services.container.register(DependencyValidatorOptionsToken, { useValue: new DependencyValidatorOptions() });
services.container.register(ValidateToken, { useClass: DependencyValidator });
// Return JSON object from element attributes.
export function elementOptions(element, prefix, options = 'options') {
    const result = {};
    const optionsKey = `${prefix}${options}`;
    const attributes = element.getAttributeNames();
    for (const attr of attributes) {
        if (attr.startsWith(prefix)) {
            const key = attr.slice(prefix.length); // Remove the prefix part
            if (options != null && attr === optionsKey) {
                try {
                    const options = JSON.parse(element.getAttribute(attr));
                    Object.assign(result, options);
                }
                catch (error) {
                    console.error(`Error parsing JSON from element ${element.name} attribute ${optionsKey} (${element.getAttribute(attr)}):`, element, error);
                }
            }
            else {
                result[key] = element.getAttribute(attr);
            }
        }
    }
    return result;
}
// Return all children of an element that match a selector. Will include the element itself if it matches the selector.
export function elementSelectorAll(element, selector) {
    const children = Array.from(element.querySelectorAll(selector));
    if (element.matches(selector))
        children.unshift(element);
    return children;
}
// Reset an element's value to the defaultValue.
export function elementResetValue(element) {
    if (element instanceof HTMLInputElement) {
        if (element.type === 'checkbox' || element.type === 'radio') {
            element.checked = element.defaultChecked;
        }
        else
            element.value = element.defaultValue;
    }
    else if (element instanceof HTMLSelectElement) {
        var options = element.querySelectorAll('option[selected]');
        if (options.length == 0) {
            element.selectedIndex = 0;
        }
        else {
            options.forEach(option => {
                if (option instanceof HTMLOptionElement)
                    option.selected = true;
            });
        }
    }
}
export function elementClearValue(element) {
    if (element instanceof HTMLInputElement) {
        if (element.type === 'checkbox' || element.type === 'radio') {
            element.checked = false;
        }
        else
            element.value = '';
    }
    else if (element instanceof HTMLSelectElement)
        element.options.selectedIndex = 0;
}
